import React, { useState } from "react";

// Click-to-load YouTube facade: shows the thumbnail until the user clicks,
// then loads the privacy-enhanced (nocookie) iframe. Avoids loading the full
// YouTube player up front. 16:9 responsive.
export default function YouTubeEmbed({ videoId, title = "YouTube video", caption }) {
  const [active, setActive] = useState(false);
  if (!videoId) return null;

  const thumb = `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
  const src = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0`;

  return (
    <figure className="youtube-embed">
      <div className="youtube-embed__frame">
        {active ? (
          <iframe
            src={src}
            title={title}
            loading="lazy"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        ) : (
          <button
            type="button"
            className="youtube-embed__poster"
            onClick={() => setActive(true)}
            aria-label={`Play video: ${title}`}
            style={{ backgroundImage: `url(${thumb})` }}
          >
            <span className="youtube-embed__play" aria-hidden="true" />
          </button>
        )}
      </div>
      {caption ? (
        <figcaption className="youtube-embed__caption">{caption}</figcaption>
      ) : null}
    </figure>
  );
}
